export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_10-540cb4f28c077a891440d2c0080469a2.jpg";